import $ from "jquery";
import moment from "moment";

$(document).ready(function(){
    if (window.currentPage == 'expert_proposal_start') {
        $('.select3').after().click(function(e) {
            e.preventDefault();
            $('.jsSelect3').select2('open');
        });
        
        $("input[name='assign_type']").on('change', function(e) {
            e.preventDefault();
            let value = $(this).val();
            if (value == 1) {
                $('#assign_id').val('').prop('disabled', true);
            } else {
                $('#assign_id').prop('disabled', false);
            }
        });

        $('#amount').on('change', function(){
            var amount = $(this).val().replace(/,/g, '');
            if (amount) {
                var amount_tax = (amount * 1.1) || 0;
                $('.amountIncludeTax').text('（税込' +formatNumber(amount_tax) + '円）');
            } else {
                $('.amountIncludeTax').text('（税込0円）');
            }
        });

        $('.number').on('keydown', function(e){
            if (e.key == 'Enter') {
                $(this).blur();
                e.preventDefault();
            }
        });

        $("input[name='price_quote']").on('change', function() {
            let value = $(this).val();
            if (value == 1) {
                $("input[name='contract_type']").val(project_contract_form);
                $("input[name='contract_type']").prop('checked', true);
                if (project_contract_form == 1) {
                    $('.jsBlock2').removeClass('active');
                    $('.jsBlock1').addClass('active');
                    $("input[name='contract_amount']").val('');
                    $(".amountIncludeTax").text(`（税込0円）`);
                } else {
                    $('.jsBlock1').removeClass('active');
                    $('.jsBlock2').addClass('active');
                    $('#hourly_salary').val('');
                    $('#working_time_month').val('');
                    $('#working_month').val(project_working_month);
                    $('.month_incom').text('0円（税込0円）');
                    $('.total_salary').text(`0円（税込0円）`);
                }
                let content = `自由記述（以下、ガイドライン）\r\n\n ■提示した見積金額について\r\n 提示金額について、見積もりの詳細をご記載ください。\r\n 発注者との認識の齟齬がなくなります。\r\n\n ■自己紹介\r\n 氏名や職種、案件に興味をもった理由などをご記載ください。\r\n\n ■職務経歴・スキル・経験\r\n 登録してあるスキル情報が少ない場合、職務経験、スキル、応募する案件に通じる経験等をご記載ください。\r\n 内容を詳細に書くことで案件とのミスマッチをさけることにつながります。\r\n\n ■案件に対する質問 \r\n 案件の内容、スケジュール等、不明な点があればご記載ください。\r\n 尚、案件受注前は発注者から提供される情報に制限がある場合がございますので、ご了承ください。`;
                if (is_company) {
                    content = `自由記述（以下、ガイドライン）\r\n\n ■提示した見積金額について\r\n 提示金額について、見積もりの詳細をご記載ください。\r\n 発注者との認識の齟齬がなくなります。\r\n\n ■アサイン紹介\r\n 職種、案件に応募する理由などをご記載ください。\r\n\n ■アサイン職務経歴・スキル・経験\r\n アサインに関する情報登録が少ない場合、アサインの職務経験、スキル、応募する案件に通じる経験等をご記載ください。\r\n 内容を詳細に書くことで案件とのミスマッチをさけることにつながります。\r\n\n ■案件に対する質問\r\n 案件の内容、スケジュール等、不明な点があればご記載ください。\r\n 尚、案件受注前は発注者から提供される情報に制限がある場合がございますので、ご了承ください。`;
                }
                $("textarea[name='content']").val(content);
            } else {
                let content =  `自由記述（以下、ガイドライン）\r\n\n ■自己紹介\r\n 氏名や職種、案件に興味をもった理由などをご記載ください。\r\n\n ■職務経歴・スキル・経験\r\n 登録してあるスキル情報が少ない場合、職務経験、スキル、応募する案件に通じる経験等をご記載ください。\r\n 内容を詳細に書くことで案件とのミスマッチをさけることにつながります。\r\n\n ■案件に対する質問\r\n 案件の内容、スケジュール等、不明な点があればご記載ください。\r\n 尚、案件受注前は発注者から提供される情報に制限がある場合がございますので、ご了承ください。`;
                if (is_company) {
                    content = `自由記述（以下、ガイドライン）\r\n\n ■アサイン紹介\r\n 職種、案件に応募する理由などをご記載ください。\r\n\n ■アサイン職務経歴・スキル・経験\r\n アサインに関する情報登録が少ない場合、アサインの職務経験、スキル、応募する案件に通じる経験等をご記載ください。\r\n 内容を詳細に書くことで案件とのミスマッチをさけることにつながります。\r\n\n ■案件に対する質問\r\n 案件の内容、スケジュール等、不明な点があればご記載ください。\r\n 尚、案件受注前は発注者から提供される情報に制限がある場合がございますので、ご了承ください。`
                }
                $("textarea[name='content']").val(content);
            }
        });

        $("input[name='contract_type']").on('change', function() {
            let value = $(this).val();
            if (value == 1) {
                $('#hourly_salary').val('');
                $('#working_time_month').val('');
                $('#working_month').val('');
                $('.month_incom').text('0円（税込0円）');
                $('.total_salary').text(`0円（税込0円）`);
            } else {
                $("input[name='contract_amount']").val('');
                $(".amountIncludeTax").text(`（税込0円）`);
            }
        });

        function formatNumber(x) {
          x = parseFloat(x);
          var parts = x.toString().split(".");
          return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        function calculation(){
            let hourly_salary = $('input[name="hourly_salary"]').val().replace(/,/g, '');
            let working_time_month = $('input[name="working_time_month"]').val().replace(/,/g, '');
            let months = $('input[name="working_month"]').val().replace(/,/g, '');
            let month_income = (hourly_salary*working_time_month) || 0;
            $('.month_income').text(formatNumber(month_income) + '円（税込' + (formatNumber(month_income*1.1)) + '円）');
            let total_salary = month_income*months
            $('.total_salary').text(formatNumber(total_salary) + '円（税込' + (formatNumber(total_salary*1.1)) + '円）');
        }

        function checkPartnerAssigned(partner_id, project_id, is_submit = false, idFormSubmit = '', is_delete = true) 
        {
            if (partner_id) {
                $.ajax({
                    url: `/expert/ajax/check-partner-assigned/${partner_id}/${project_id}`,
                    type: 'get',
                    dataType: "json",
                    beforeSend: function() {
                        $(`#popup-info-body`).html('');
                    },
                }).done(async function (res) {
                    if (res.success) {
                        let data = res.data;
                        let allow_assign = data.allow_assign;
                        let confirm_withdraw = data.confirm_withdraw;
                        if (!allow_assign) {
                            let title = '';
                            let content = '';
                            if (confirm_withdraw) {
                                title = `<p class="txtCheck2_ttl mb0">${data.title}</p>`;
                            } else {
                                title = `<p class="txtCheck2_ttl">${data.title}</p>`;
                                content = `<ul class="txtCheck2_list">${data.content}</ul>`
                            }
                            let html = title + content;
                            if (is_delete) {
                                $('input[name="assign_id"]').val('');
                            }
                            if (!data.check_assigned) {
                                $('#popupInfo .popupBtn').css('display', 'none')
                            }else{
                                $('#popupInfo .popupBtn').css('display', '')
                            }
                            $(`#popup-info-body`).append(html);
                            $('#popupInfo').addClass('show');
                        } else {
                            if (is_submit && idFormSubmit != '') {
                                $(`#${idFormSubmit}`).submit();
                            }
                        }
                    }
                }).fail(function (data) {
                    let res = JSON.parse(data.responseText);
                    if (!res.success) {
                        alert('エラーが発生しました');
                    }
                }); 
            } else {
                if (is_submit && idFormSubmit != '') {
                    $(`#${idFormSubmit}`).submit();
                }
            }
        }

        $('.calculation').on('change', function () {
            calculation();
        });

        $(document).on('select2:select', '#assign_id', function(e) {
            e.preventDefault();
            let partner_id = $(this).val();
            let project_id = $('input[name="project_id"]').val();
            checkPartnerAssigned(partner_id, project_id);
        });

        $(document).on('click', '#btn-apply-project', function(e) {
            e.preventDefault();
            let partner_id = $('#assign_id').val();
            let project_id = $('input[name="project_id"]').val();
            checkPartnerAssigned(partner_id , project_id, true, 'formApplyProjet', false);

        });
    }

    if (
        window.currentPage == 'expert-corp-top'
        || window.currentPage == 'expert_project_apply_list' 
        || window.currentPage == 'corp_expert_project_assign_list' 
        || window.currentPage == 'corp_expert_project_apply_list'
        || window.currentPage == 'corp_expert_project_offer_list'
        || window.currentPage == 'corp_expert_project_unsuccess_list'
    )
    {
        if (window.currentPage != 'expert-corp-top') {
            setTimeout(() => {
                handleActiveParamSearch();
            }, 100);
        }

        function handleActiveParamSearch() {
            let urlSearchParams = new URLSearchParams(window.location.search)
            const params = Object.fromEntries(urlSearchParams.entries());
            if (params.transaction) {
                let listTransaction = params.transaction.split(', ');
                let listJsItem = $('.jsItem');
                listTransaction.forEach((value, index) => {
                    switch (Number(value)) {
                        case 1:
                            $(listJsItem[1]).addClass('active');
                            break
                        case 2:
                            $(listJsItem[0]).addClass('active');
                            break;
                        default:
                            break;
                    }
                })
            }
            if (params.manager) {
                $('#expert_manager').val(params.manager).trigger('change');
            }
            if (params.orderBy) {
                $('#orderBy').val(params.orderBy);
            }
        }

        function getFilterTransaction() {
            let listJsitemActive = $('.jsItem.active');
            let transaction = '';
            if (listJsitemActive.length > 0) {
                listJsitemActive.map((index, item) => {
                    let indexJsItem = $('.jsItem').index(item);
                    let number_transaction = indexJsItem == 0 ? 2 : 1
                    if (transaction) {
                        transaction +=  `, ${number_transaction}`;
                    } else {
                        transaction +=  `${number_transaction}`;
                    }
                })
            }
            return transaction;
        }

        function getFilterExpertManager() {
            let manager_id = $('#expert_manager').val();
            return manager_id;
        }

        function getFilterOrderBy() {
            let manager_id = $('#orderBy').val();
            return manager_id;
        }

        function changeUrlParameter() {
            let url = new URL(window.location.href)
            let search_params = url.searchParams;
            let transaction = getFilterTransaction();
            let manager_id = getFilterExpertManager();
            let orderBy = getFilterOrderBy();

            search_params.delete('transaction');
            search_params.delete('manager');
            search_params.delete('page');
            search_params.delete('orderBy');

            if (transaction) {
                search_params.append('transaction', transaction);
            }
            if (manager_id) {
                search_params.append('manager', manager_id);
            }
            if (orderBy) {
                search_params.append('orderBy', orderBy);
            }
            url.search = search_params.toString();
            let new_url = url.toString();
            window.history.pushState({ additionalInformation: 'Updated the URL with JS' }, "Title", new_url);
            window.location.reload();
        }

        $(document).on('click', '.jsItem, .jsClose', function(e) {
            e.preventDefault();
            changeUrlParameter();
        });


        $(document).on('select2:select', '#expert_manager', function(e) {
            e.preventDefault();
            changeUrlParameter();
        });

        $(document).on('change', '#orderBy', function(e) {
            e.preventDefault();
            changeUrlParameter();
        });

        $(document).on('change', '.selectStyle', function(e) {
            e.preventDefault();
            let value = $(this).val();
            let data_select_old = $(this).attr('data-selected');
            let proposal_id = $(this).attr('data-proposal-id');
            let selected_block = $(this).attr('data-selected-block');
            if(!selected_block && !proposal_id) {
                return false;
            }
            let makeSure = confirm("本当にこの人を選びますか？");
            if (makeSure) {
                $(this).attr('data-selected', value);
                let url = window.pathChangeManager;
                let inputs = {};
                inputs['expert_id'] = value;
                inputs['proposal_id'] = proposal_id;
                inputs['selected_block'] = selected_block;
                let _token = $('meta[name="csrf-token"]').attr("content");
                inputs['_token'] = _token
                $.ajax({
                    url: url,
                    data: inputs,
                    type: 'POST',
                    dataType: "json",
                    error: function(res) {
                        alert('エラーが発生しました');
                    }
                }).done(function (res) {
                    if(res.success == false) {
                        return false;
                    }
                    window.location.reload();
                });
            } else {
                if (data_select_old) {
                    $(this).val(data_select_old);
                } else {
                    $(this).val('');
                }
            }
        });
    }

    if (
        window.currentPage == 'expert-top'
        || window.currentPage == 'expert_project_assign_list'
        || window.currentPage == 'expert-corp-top'
        || window.currentPage == 'corp_expert_project_assign_list'
        || window.currentPage == 'expert_project_unsuccess_list'
    ) {
        $(document).on('click', '.jsProposalAssign', function(e) {
            e.preventDefault();
            let id = $(this).data('id');
            let type = $(this).data('type');
            let url_next = $(this).attr('href');
            $.ajax({
                headers: {
                  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                url: '/add-proposal-assign',
                data: {
                  'id': id,
                  'type': type,
                },
                type: 'post',
                dataType: "json",
                success: function(response) {
                    if (response.success) {
                        window.location.href = url_next;
                    }
                },
                error: function(result) {
                    let response = JSON.parse(result.responseText);
                    let message = response.message;
                    alert(message);
                }
            });
        });
    }
});
